import type { SimulatorRequest } from "common/types/Simulator";

// Libellés partagés par l'écran et les exports : le fichier reprend exactement les mots affichés.
export const ownershipLabels: Record<SimulatorRequest["ownership"], string> = { full: "Pleine propriété", bare: "Nue-propriété", usufruct: "Usufruit" };
export const allocationLabels: Record<SimulatorRequest["allocation"], string> = {
	equal: "À parts égales",
	amount: "Montants libres (€)",
	percent: "Pourcentages du budget",
	shares: "Nombre de parts",
};
export const creditTypeLabels: Record<SimulatorRequest["credit"]["type"], string> = { amortizing: "Amortissable", bullet: "In fine" };
export const deferTypeLabels: Record<SimulatorRequest["credit"]["deferType"], string> = {
	partial: "Partiel : intérêts payés",
	total: "Total : intérêts capitalisés",
};
export const taxRegimeLabels: Record<SimulatorRequest["tax"]["regime"], string> = { real: "Réel simplifié", micro: "Micro-foncier (sous conditions)" };

export const options = <T extends string>(labels: Record<T, string>) => Object.entries(labels) as [T, string][];
